import type { ProjectStatusChangedEvent } from "@zplanem/responses"
import type React from "react"
import { getTranslations } from "../../../i18n"
import { useLocale } from "../../../locale-context"
import { JournalRowShell } from "../journal-row-shell"
import { interpolate, resolveActor } from "../resolve-actor"

const StatusChangedIcon: React.FC = () => (
	<svg
		viewBox="0 0 16 16"
		fill="none"
		stroke="currentColor"
		strokeWidth="1.5"
		strokeLinecap="round"
		strokeLinejoin="round"
		className="w-5 h-5"
		aria-hidden="true"
	>
		<path d="M2.5 8h11M10 4.5l3.5 3.5L10 11.5" />
	</svg>
)

export function ProjectStatusChangedRow({
	event,
}: {
	event: ProjectStatusChangedEvent
}) {
	const { locale } = useLocale()
	const t = getTranslations(locale)
	const actor = resolveActor(event.actor, t)
	// Tolerate unknown status values by falling back to the raw wire string.
	const statuses = t.projects.statuses as Record<string, string>
	const from = statuses[event.payload.from] ?? event.payload.from
	const to = statuses[event.payload.to] ?? event.payload.to
	return (
		<JournalRowShell
			icon={<StatusChangedIcon />}
			headline={interpolate(t.journal.events.projectStatusChanged.label, {
				from,
				to,
			})}
			actor={actor}
			iso={event.createdAt}
			eventType="project.status_changed"
			aria={interpolate(t.journal.events.projectStatusChanged.aria, {
				actor,
				from,
				to,
			})}
		/>
	)
}
